import {
  Button,
  Checkbox,
  EmptyState,
  Icons,
  Intent,
  Size,
  Spinner,

} from 'construct-ui';
import TreeComponent from '../../components/treeview/tree.component';
import ViewBase from '../view-base.view';
import goodMovementModel from '../../models/posm/goods-movement.model';
import { HIERACHY_LEVEL_MAP } from '../../models/posm/posm.constant';

/**
 *
 *
 * @author cmc.ttanh18
 */
const hierachyMap = [
  'main',
  'goodsType',
  'division',
  'model',
  'basicModel',
  'movementType',
  'storageLocation',
  'warehouse',
];

export default function POSMLevelHierarchy() {
  ViewBase.call(this);

  let isHierachyLoading = false;
  const LIST_HEIGHT = '700px';

  let maxCurrentLevel = goodMovementModel.isFromPOSMGoodMovement ? 1 : 5;
  const DEFAULT_FIELD_VALUES = {
    parentName: '',
    code: '',
    name: '',
    description: '',
    etcInfo: '',
    hierarchyLevel: 1,
    status: '',
  };
  let hierachyObj = {
    Name: '',
    Description: '',
    Level: '',
    IsExpiry: false,
    Active: true,
    Parentcode: '',
    Controlcode: '',
  };
  let isTreeLoading = false;
  let isDetailsLoading = false;
  let hierarchyTree = [];
  let hierarchyDetail = structuredClone(DEFAULT_FIELD_VALUES);
  const onSave = (e) => {
    e.preventDefault();
    if (!this.validateForm(e)) {
      return false;
    }
    isHierachyLoading = true;
    hierachyObj = {
      ...hierachyObj,
      ParentId: hierarchyDetail.parentId,
      Parentcode: hierarchyDetail.parentCode,
      Level: hierarchyDetail.hierarchyLevel,
      Controlcode: hierachyObj.Controlcode
        ? hierachyObj.Controlcode
        : hierachyObj.Name
    };
    goodMovementModel
      .addHierachyDetail(hierachyObj)
      .then((data) => {
        isHierachyLoading = false;
        if (data[0].transStatus != 'SUCCESS') {
          this.showErrorMessage(data[0].message, null, null);
        } else {
          this.showMessage(this.getText('EM00000004', 'Success'), null, () => {
            m.route.set('/posm-goods-movement');
          });
        }
      })
      .catch((err) => {
        isHierachyLoading = false;
        this.showErrorMessage(err, null, null);
      });
  };
  const handleOninput = (e, propName) => {


    hierachyObj[propName] = e.target.value;



  };
  const getHierarchyTree = (hierarchyType) => {
    isTreeLoading = true;
    hierarchyTree = createHierarchyTree(
      goodMovementModel.getMovementDetail(),
      1,
      null
    );
    isTreeLoading = false;
  };

  const flattenArray = (arr) =>
    arr.flatMap((item) => {
      let { children, ...rest } = item;
      return [rest, ...flattenArray(children)];
    });

  const getHierarchyDetail = (hierarchyCode) => {
    isDetailsLoading = true;
    let hierachyArray = hierarchyTree;
    hierarchyDetail = flattenArray(hierachyArray).find((item) => item.code === hierarchyCode);
    isDetailsLoading = false;
    m.redraw();
  };

  const showLevelLabel = (level) => `${this.getText('LT00001335', 'New')} ${this.getText(HIERACHY_LEVEL_MAP[level]?.code, HIERACHY_LEVEL_MAP[level]?.name)}`

  function createHierarchyTree(movementDetail, currentLevel, parent) {
    let result = [];
    let type = hierachyMap[currentLevel - 1];
    if (!type || !movementDetail[type]) {
      return result;
    }
    if (currentLevel > maxCurrentLevel) {
      maxCurrentLevel = currentLevel;
    }
    if (!parent) {
      result[result.length] = {
        id: movementDetail[type].id,
        code: movementDetail[type].code,
        name: movementDetail[type].name
          ? movementDetail[type].name
          : showLevelLabel(currentLevel),
        hierarchyLevel: currentLevel,
        parentId: 0,
        parentCode: '0',
        status: true,
        children: movementDetail[type].code
          ? createHierarchyTree(
            movementDetail,
            currentLevel + 1,
            movementDetail[type].code ? movementDetail[type] : null
          )
          : [],
      };
    } else {
      result[result.length] = {
        id: movementDetail[type].id,
        code: movementDetail[type].code,
        name: movementDetail[type].name
          ? movementDetail[type].name
          : showLevelLabel(currentLevel),
        hierarchyLevel: currentLevel,
        parentId: parent.id,
        parentCode: parent.code,
        parentName: parent.name,
        IsExpiry: movementDetail[type]?.IsExpiry ? movementDetail[type].IsExpiry : null,
        status: true,
        children: movementDetail[type].code
          ? createHierarchyTree(
            movementDetail,
            currentLevel + 1,
            movementDetail[type].code ? movementDetail[type] : null
          )
          : [],
      };
    }
    return result;
  }
  const handleBack = () => { m.route.set('/posm-goods-movement'); }
  return {
    oninit: () => {
      if (!goodMovementModel.isFromPOSMGoodMovement) {
        goodMovementModel.getHierachyTreeByLevel(1, 5).then((data) => {
          hierarchyTree = data
        })
      } else {
        getHierarchyTree();
      }
    },

    onremove: () => {
      goodMovementModel.isGoingtoHierachy = false;
      goodMovementModel.isFromPOSMGoodMovement = false;
    },
    view: () => [
      isHierachyLoading &&
      m(Spinner, { fill: true, background: true, active: true }),
      m(
        '.row.g-1',
        { style: { height: LIST_HEIGHT } },
        // LEFT PANE
        m('.col-4.h-100',
          m('.card.h-100',
            m('.card-header.d-flex.justify-content-between.gap-2',
              m('.h2',
                m('i.bi.bi-arrow-left.cursor-pointer', {
                  onclick: handleBack
                }),
                this.getText('LT00001313', 'POSM Level Hierarchy')),
              // hierarchyDetail?.hierarchyLevel > 3 && m(Button, {
              //   iconLeft: Icons.PLUS,
              //   intent: 'primary',
              //   label: showLevelLabel(hierarchyDetail?.hierarchyLevel),
              //   size: Size.SM,
              //   onclick: () => { },
              // })
            ),
            m('.card-body.h-100.overflow-auto',
              m('.d-flex.h-100.flex-column.gap-3',
                m('.flex-fill.overflow-auto.position-relative',
                  hierarchyTree && hierarchyTree.length > 0
                    ? m(TreeComponent, {
                      isOpenTheLastLevel: goodMovementModel.isFromPOSMGoodMovement,
                      getNodeDetail: getHierarchyDetail,
                      items: hierarchyTree,
                      multiple: true,
                      globalOnClick: (value) => {
                        getHierarchyDetail(value);
                      },
                    })
                    : m(EmptyState, {
                      class: 'placeholder-text-color',
                      icon: Icons.ARCHIVE,
                      content: this.getText('LT00000317', 'No results found'),
                      fill: true,
                    })
                ),
                isTreeLoading &&
                m(Spinner, { fill: true, background: true, active: true })
              )
            )
          )
        ),

        // RIGHT PANE
        m('.col-8',
          m('.card',
            m('.card-header',
              m('.h2', showLevelLabel(hierarchyDetail?.hierarchyLevel))
            ),
            m('.card-body',
              m('form.row.g-3.needs-validation[novalidate]',
                { onsubmit: onSave },
                hierarchyDetail?.hierarchyLevel != 1 && [
                  m('.col-4.position-relative',
                    m('label.form-label',
                      this.getText('LT00000777', 'Parent Name')
                    ),
                    m('input.form-control', {
                      disabled: true,
                      type: 'text',
                      value: hierarchyDetail?.parentName,
                    })
                  ),
                  m('.col-8'),
                ],
                m('.col-4.position-relative',
                  m('label.form-label.mandatory',
                    this.getText('LT00000011', 'Name')
                  ),
                  m('input.form-control', {
                    disabled: (hierarchyDetail?.hierarchyLevel || hierarchyDetail?.level) < maxCurrentLevel,
                    type: 'text',
                    required: true,
                    maxlength: 100,
                    id: '#name',
                    value: ((hierarchyDetail?.hierarchyLevel || hierarchyDetail?.level) < maxCurrentLevel) ? hierarchyDetail?.name : hierachyObj.Name,
                    oninput: (e) => {
                      handleOninput(e, 'Name');
                    },
                  }),
                  m('.invalid-tooltip', this.getText('LT00000903', 'Please check required fields'))
                ),
                m('.col-4.position-relative',
                  ((hierarchyDetail?.hierarchyLevel || hierarchyDetail?.level) == 2 ||
                    (hierarchyDetail?.hierarchyLevel || hierarchyDetail?.level) == 3) && [
                    m('label.form-label.mandatory', this.getText('LT00000778', 'Code')),
                    m('input.form-control', {
                      disabled: (hierarchyDetail?.hierarchyLevel || hierarchyDetail?.level) < maxCurrentLevel,
                      type: 'text',
                      required: true,
                      maxlength: 3,
                      value: ((hierarchyDetail?.hierarchyLevel || hierarchyDetail?.level) < maxCurrentLevel) ? hierarchyDetail?.code : hierachyObj.Controlcode,
                      id: '#code',
                      oninput: (e) => {
                        handleOninput(e, 'Controlcode');
                      },
                    }),
                    m('.invalid-tooltip', this.getText('LT00000903', 'Please check required fields')),
                  ]
                ),

                m('.col-4'),
                hierarchyDetail?.hierarchyLevel == 2 && [
                  m('.col-4',
                    m('label.form-label.pe-2[for=goodstype]',
                      this.getText('LT00001271', 'Expiry?')
                    ),
                    m(Checkbox, {
                      disabled: !goodMovementModel.isFromPOSMGoodMovement || hierarchyDetail?.hierarchyLevel < maxCurrentLevel,
                      checked: hierachyObj?.IsExpiry || hierarchyDetail?.IsExpiry,
                      onchange: (e) => {
                        hierarchyDetail.IsExpiry = e.target.checked
                        hierachyObj.IsExpiry = e.target.checked
                      }
                    })
                  ),
                ],
                // hierarchyDetail?.hierarchyLevel == 5 && [
                //   m('.col-4',
                //     m('label.form-label.pe-2[for=goodstype]',
                //       this.getText('LT00001245', 'Serial No')
                //     ),
                //   ),
                // ],
                m('.col-2',
                  m('.d-flex.flex-column.h-100',
                    m('label.form-label', this.getText('LT00000015', 'Status')),
                    m('.d-flex.flex-fill.align-items-center',
                      m('div',
                        hierarchyDetail?.status
                          ? m(
                            '.badge.rounded-pill.green-bg-status',
                            this.getText('LT00000025', 'Active')
                          )
                          : m(
                            '.badge.rounded-pill.grey-bg-status',
                            this.getText('LT00000029', 'Inactive')
                          )
                      )
                    )
                  )
                ),
                m('.col.d-flex.justify-content-end.align-items-end.gap-2',
                  m(Button, {
                    disabled: !goodMovementModel.isFromPOSMGoodMovement || hierarchyDetail?.hierarchyLevel < maxCurrentLevel,
                    type: 'submit',
                    intent: Intent.PRIMARY,
                    label: this.getText('LT00000022', 'Save'),
                  }),
                  m(Button, {
                    label: this.getText('LT00000021', 'Close'),
                    onclick: handleBack,
                  })
                  // m(Button, {
                  //   iconLeft: Icons.PLUS,
                  //   intent: Intent.PRIMARY,
                  //   label: this.getText('LT00001291', 'New Division'),
                  //   onclick: () => {
                  //   }
                  // }),
                  // m(Button, {
                  //   iconLeft: Icons.EDIT_2,
                  //   intent: Intent.POSITIVE,
                  //   label: this.getText('', 'Edit'),
                  //   onclick: () => {
                  //   }
                  // }),
                  // m(Button, {
                  //   iconLeft: Icons.X,
                  //   intent: Intent.NEGATIVE,
                  //   label: this.getText('', 'Delete'),
                  //   onclick: () => {
                  //   }
                  // })
                )
              )
            ),
            isDetailsLoading &&
            m(Spinner, { active: true, fill: true, background: true })
          )
        )
      ),
      this.getBaseViews(),
    ],
  };
}
